import { KeyboardEvent, useEffect, useRef } from "react";
import { inputFormHeightOption, titleMRClass } from "src/components/common/common";
import { handleKeyDown } from "src/utils/commonForm/commonFormUtils";
import { XButtonForm } from "./XButtonForm";

interface Props {
	label: string;
	titleWidth?: number;
    value: string;
	custNmValue: string;
	editable?: boolean;
	handleFoucsId?: string;
    name: string;
	titleless?: boolean;
	codeInputless?: boolean;
	custNmInputless?: boolean;
	wrapperOption?: {
		wrapperStyle: string;
		titleStyle: string;
		codeInputStyle: string;
		custNmInputStyle: string;
	};
	handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onDoubleClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
	onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const CodeForm = (props: Props) => {
	const { 
		label,
		titleWidth,
		value,
		custNmValue = "",
		editable = true,
		handleFoucsId = "",
		name,
		titleless = false,
		codeInputless = false,
		custNmInputless = false,
		wrapperOption = {
			wrapperStyle: "w-[350px] min-w-[350px] mr-[10px] mb-[5px]",
			titleStyle: "w-[150px] min-w-[150px] text-left",
			codeInputStyle: "w-[90px] min-w-[90px]",
			custNmInputStyle: "w-[105px] min-w-[105px]"
		},
		handleChange = () => { console.log("handleChange"); },
		onDoubleClick = () => { console.log("handleCustDoubleClick"); },
	} = props;

	const onKeyDown = props.onKeyDown != null ? props.onKeyDown : handleKeyDown;

	const inputRef = useRef<HTMLInputElement>(null);

	const onclickAction = (e: React.MouseEvent<HTMLInputElement>) => {
		if(!codeInputless) {
			inputRef.current?.focus(); 
		}else if(codeInputless) {
			onDoubleClick(e as React.MouseEvent<HTMLInputElement>);
		}
	}

	return (
		<div className={`flex ${wrapperOption.wrapperStyle}`} style={titleWidth ? { width: 'max-content' } : undefined}>
			{!titleless && 
				<p	className={`form-title ${wrapperOption.titleStyle} ${titleMRClass} cursor-pointer ${titleless ? 'hidden' : ''}`}
					style={titleWidth ? { width: titleWidth, minWidth: titleWidth, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } : undefined}
					title={label}
					onClick={(e) => { onclickAction(e as React.MouseEvent<HTMLInputElement>); }}
					onKeyDown={(e) => { if(e.key === "Enter") inputRef.current?.focus(); }}
					tabIndex={editable ? 0 : -1}
				>
					{label}
				</p>
			}
			{!codeInputless && (
				<>
				<div className={`relative`}>
				<input
					className={`${editable ? 'bg-white' : 'bg-gray-disable'} ${inputFormHeightOption} text-left rounded-[4px] pl-[2px] border-[1px] mr-[5px] ${wrapperOption.codeInputStyle}`}
					id={handleFoucsId}
					name={name}
					value={value}
					ref={inputRef}
					onChange={handleChange}
						onDoubleClick={(e) => { if(editable) onDoubleClick(e as React.MouseEvent<HTMLInputElement>); }}
						onKeyDown={(e) => { onKeyDown(e); }}
					/>
					{editable &&
						<XButtonForm
							className="right-[6px]"
							onClick={() => {
								if (inputRef.current && name && handleChange) {
									const event = { target: { name, value: '' } } as React.ChangeEvent<HTMLInputElement>;
									handleChange(event);
								}
							}}
						/>
					}
				</div>
				</>
			)}
			{!custNmInputless && 
				<p 
					className={`bg-gray-disable text-left pl-[2px] rounded-[4px] border-[1px] flex items-center truncate ${wrapperOption.custNmInputStyle} cursor-pointer ${inputFormHeightOption}`}
					id={handleFoucsId + `_codeLabel`}
					onClick={(e) => { onclickAction(e as React.MouseEvent<HTMLInputElement>); }}
					tabIndex={!codeInputless ? -1 : 0}
				>
					{custNmValue}
				</p>
			}
		</div>		
	)
}
